import React, { useEffect, useState } from "react";
import HeaderAddNewSite from "./HeaderAddNewSite";
import AddSiteFull from "./AddSiteFull";
import Loader from "./Loader";
import { Container, CssBaseline } from "@mui/material";

export default function PageAddNewSite() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  }, []);

  return (
    <Container size="sm">
      <CssBaseline />
      {loading ? (
        <Loader />
      ) : (
        <>
          <HeaderAddNewSite />
          <AddSiteFull />
        </>
      )}
    </Container>
  );
}
